module.exports = __webpack_public_path__ + "static/media/icon-protegidos.9b233922.svg";